export const BirdviewAttentionGroup = {
  AwaitingProvider: 'awaitingProvider',
  NoActivity: 'noActivity',
  Overdue: 'overdue',
  Unassigned: 'unassigned',
}

export const BIRDVIEW_ATTENTION_OPEN_GROUP_INDEX = 0

export const BIRDVIEW_ATTENTION_GROUP_LABEL_KEY = {
  [BirdviewAttentionGroup.AwaitingProvider]:
    'DashboardBirdview.AttentionAwaitingProviderGroupKey',
  [BirdviewAttentionGroup.NoActivity]:
    'DashboardBirdview.AttentionNoActivityGroupKey',
  [BirdviewAttentionGroup.Overdue]:
    'DashboardBirdview.AttentionOverdueGroupKey',
  [BirdviewAttentionGroup.Unassigned]: 'DashboardBirdview.TileUnassignedKey',
}
